/*****************************
 * Serialize array
 *****************************/
var serializeArray = function (form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button', 'radio', 'select-one', 'select-multiple', 'checkbox'].indexOf(field.type) > -1) return;
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
    arr.push({
      name: field.name,
      value: field.value
    });
  });
  return arr;
};

/***************************
 * Serialize object
 ***************************/
var serializeObject = function (form) {
  var obj = {};
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button', 'radio', 'select-one', 'select-multiple', 'checkbox'].indexOf(field.type) > -1) return;
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
    obj[field.name] = field.value;
  });
  return obj;
}

/***************************
 * Post as json using fetch
 ***************************/
var liveUrl = "https://order.ingager.com/api/v1/";
var stagingUrl = "https://stagingorder.ingager.com/api/v1/";
var localUrl = "http://localhost:8888/";
var testMode = false;
var environment = liveUrl;
if (location.href.indexOf('http://localhost:1234/') !== -1) {
  environment = localUrl;
  testMode = true;
}

var postAsJson = function (data, callback) {
  console.log(data);
  fetch(environment + 'neworder.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    callback(json);
  });
};

/*****************************
 * Post to order
 *****************************/
var liveUrl = "https://order.ingager.com/api/v1/";
var stagingUrl = "https://stagingorder.ingager.com/api/v1/";
var localUrl = "http://localhost:8888/";
var testMode = false;
var environment = liveUrl;
// if (location.href.indexOf('http://localhost:1234/') !== -1) {
//   environment = localUrl;
//   testMode = true;
// }

function postToOrder(data, callback) {
  var params = typeof data == 'string' ? data : Object.keys(data).map(
    function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
  ).join('&');

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', environment + 'order.php');
  xhr.onload = function () {
    callback(xhr.responseText);
  }
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  xhr.send(params);
}

/*****************************
 * Analytical data
 *****************************/
function analyticalData(data) {
  var params = typeof data == 'string' ? data : Object.keys(data).map(
    function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
  ).join('&');

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', environment + 'view.php');
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(params);
  return xhr;
}

/*****************************
 * Post image
 *****************************/
function postImage(data, callback) {
  var formData = new FormData();
  formData.append('imageFile', data.file);

  // Send form data to backend
  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', 'https://atab.me/c/carmex/summer-competition/submission.php', true);
  xhr.onload = function () {
    callback(xhr.responseText);
  }
  xhr.send(formData);
}
